import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { InView } from 'react-intersection-observer';
import uuidv4 from 'uuid/v4';

import { libraryShape, listShape, userIdentityShape } from '@bibliocommons/bc-prop-types';

import ListCardAdapter from 'app/components/shared/ListCardAdapter';

import './ListsRow.scss';

const makeImpressionId = (listId, impressionIdSuffix) => `${listId}-${impressionIdSuffix}`;

export default class ListsRow extends React.PureComponent {
  renderItem(list) {
    const { stacked, library, users, handleListTitleClick, handleListImageClick, handleListImpression } = this.props;
    const className = cn('list-item', stacked ? 'col-sm-12' : 'col-sm-3');
    const creator = users.get(list.getIn(['owner', 'id']).toString());
    const impressionIdSuffix = uuidv4();
    const listId = list.get('id');

    const handleVisibility = visibleListId => {
      return isVisible => {
        if (isVisible) {
          handleListImpression({ impressionId: makeImpressionId(visibleListId, impressionIdSuffix), listId });
        }
      };
    };

    return (
      <li key={listId} className={className}>
        <InView threshold={1} triggerOnce onChange={handleVisibility(listId)}>
          <ListCardAdapter
            creator={creator}
            handleListImageClick={() =>
              handleListImageClick({
                impressionId: makeImpressionId(listId, impressionIdSuffix),
                listId
              })}
            handleListTitleClick={() =>
              handleListTitleClick({
                impressionId: makeImpressionId(listId, impressionIdSuffix),
                listId,
                listTitle: list.get('name')
              })}
            horizontal={stacked}
            library={library}
            list={list}
            smallHeading
            titleTag="div"
          />
        </InView>
      </li>
    );
  }

  render() {
    const { lists, className, stacked } = this.props;
    const classNames = cn('cp-lists-row', 'row', className, { stacked });

    return <ul className={classNames}>{lists.map(list => this.renderItem(list))}</ul>;
  }
}

ListsRow.propTypes = {
  className: PropTypes.string,
  users: ImmutablePropTypes.mapOf(userIdentityShape),
  library: libraryShape,
  lists: ImmutablePropTypes.listOf(listShape),
  stacked: PropTypes.bool,
  handleListTitleClick: PropTypes.func,
  handleListImageClick: PropTypes.func,
  handleListImpression: PropTypes.func
};
